<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-right">
							<router-link class="btn GeneralLeave-back btnBack" to="/modificaciones-datos-personales/nueva">
							    <font-awesome-icon icon="fa-solid fa-circle-plus" /> Nueva modificación
							</router-link>
						</div>
						<div class="title">
							<h3>Modificaciones de Datos Personales</h3>
						</div>
					</div>
					<div class="itemList-header">
						<h1>Modificaciones de Datos Personales</h1>
					</div>
					<div class="itemList-content row">
						<div v-if="modificaciones.length == 0" class="AdvanceRequest-title col-md-12 NotFound text-center"> No hay resultados </div>
						<section v-else id="no-more-tables" class="col-md-12 text-center">
							<table class="table" id="tblGeneralLeave">
								<thead>
									<tr>
										<th class="colDate">Fecha</th>
										<th class="colType">Tipo de modificación</th>
										<th class="colType">Estado</th>
										<th class="colAction">Acción</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="modificacion in modificaciones">
										<td class="colDate" data-title="Fecha : ">
											{{ formatDate(modificacion.fecha) }}
										</td>
										<td class="colType" data-title="Tipo de modificación : ">
											{{ modificacion.descripcionModificacion }}
										</td>
										<td class="colType" data-title="Estado : ">
											{{ modificacion.estado }}
										</td>
										<td class="colAction" data-title="Acción : ">
											<a 
											v-if="modificacion.estado=='En Curso'" 
												href="javascript:void(0);" 
												class="btnDelete" 
												@click="borrar(modificacion.id)"
											>
												<font-awesome-icon icon="fa-solid fa-times" />
											</a>
											<router-link :to="`/modificaciones-datos-personales/ver/${modificacion.id}`">
												<font-awesome-icon icon="fa-solid fa-eye" />
											</router-link>
											&nbsp;&nbsp;
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
					<div class="itemList-footer">
						<div class="pagination text-center Generalleave-paging"></div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        name: "ModificacionesDatosPersonales",
		components: {
            Encabezado,
            Footer,
        },
		data() { 
			return{}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
		},
		watch:{
			guardadoOK: function(newValue){
				if (newValue){
					this.$toast.open({
						message: "La Solicitud de Modificación se ha borrado correctamente",
						type: "success",
						duration: 1000,
						dismissible: false,
						position: "top",
						onDismiss: this.redireccionListaModificacionesDatosPersonales
					});
				}
			}
		},
		computed:{
			modificaciones: function(){
				let modificaciones = this.$store.state.perfil.modificaciones || [];
			
				return Array.isArray(modificaciones)? modificaciones : [modificaciones];
			},
			guardadoOK: function(){
				return this.$store.state.guardadoOK;
			},
		},
		methods:{
			borrar: function(id){
				if (confirm('Atención: Borrar Solicitud de Modificación'))
					this.$store.dispatch('borrarModificacion', {'id': id});
			},
			redireccionListaModificacionesDatosPersonales: function(){
				//router.replace('/modificaciones-datos-personales');
				this.$store.commit('establecerGuardadoOK', false);
			},
			formatDate: function(date) {
				return this.moment(date).format('DD/MM/YYYY');
			}
		}
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
